var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.base + ' ' + (_vm.model.isFollow ? 'btn-blue' : 'btn-default'),on:{"click":function($event){return _vm.$com.addFollow(_vm.model, _vm.type)}}},[_c('span',{staticClass:"icon iconfont icon-shoucang"}),_vm._v(_vm._s(_vm.model.isFollow ? '移除' : '收藏')+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69026997","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/ButtonFollowView.vue
// module id = null
// module chunks = 